import BellGrayFull from '@assets/images/common/icon/header/bell-gray-full.svg';
import BellWhite from '@assets/images/common/icon/header/bell-white.svg';
import BellWhiteFull from '@assets/images/common/icon/header/bell-white-full.svg';

import { BellProps } from './type';

export const WhiteBell = ({
  handleToggle,
  notifications,
  isExistNewNotification = false,
}: BellProps) => {
  const bell = () => {
    if (isExistNewNotification) {
      return BellWhite;
    }
    return notifications.length > 0 ? BellWhiteFull : BellGrayFull;
  };

  return (
    <div className='flex size-[60px] items-center justify-center lg:size-[20px]'>
      <button
        type='button'
        onClick={handleToggle}
        className='relative'
        aria-label='通知'
      >
        {isExistNewNotification && (
          <div className='absolute right-0 top-0 size-[6px] rounded-full bg-warning-500'></div>
        )}
        <img
          className=''
          src={bell()}
          alt=''
          width='17'
          height='20'
        />
      </button>
    </div>
  );
};
